export default "__VITE_ASSET__Bzc1wBy3__"